import { render, staticRenderFns } from "./FillingType.vue?vue&type=template&id=38889d8a&scoped=true&"
import script from "./FillingType.vue?vue&type=script&lang=js&"
export * from "./FillingType.vue?vue&type=script&lang=js&"
import style0 from "./FillingType.vue?vue&type=style&index=0&id=38889d8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38889d8a",
  null
  
)

export default component.exports